import styled from 'styled-components'
import { theme } from '../../theme/theme'
import { BodyLargeMedium, BodyMedium } from '../styles/Typography'
import { useTranslation } from 'react-i18next'
import { useCheckItemMutation } from '../../api/ester-b2b-api/private/healthPlan/healthPlanQueries'
import { PreviewGuard } from '../PreviewGuard'
import { Checkbox } from '../inputs/Checkbox'
import { boxShadow } from '../../theme/shadows'
import { CheckListItem } from '../../api/ester-b2b-api/private/healthPlan/types'
import { useEmitEvent } from '../../hooks/analytics/useEmitEvent'
import { TrackingEvents } from '@estercare/ester-shared'
import { NewRecommendationsBanner } from './NewRecommendationsBanner'

export const CheckList = ({
  checkListItems,
  isFollowUpHandled,
}: {
  checkListItems?: CheckListItem[]
  isFollowUpHandled: boolean
}) => {
  const { t } = useTranslation()
  const { mutate: toggleItemMutation, isPending } = useCheckItemMutation()
  const emitEvent = useEmitEvent()

  const handleCheckboxChange = (priority: number) => {
    const item = checkListItems?.find((i) => i.priority === priority)
    toggleItemMutation({ priority })
    if (item) {
      emitEvent({
        eventType: TrackingEvents.CLICK_CHECKLIST_ITEM,
        options: {
          metadata: {
            checklist_item_id: item.id,
            checklist_item: item.title,
            checked: String(!item.checked),
          },
        },
      })
    }
  }

  if (!checkListItems || checkListItems.length === 0) {
    return <PreviewGuard />
  }

  return (
    <CheckListWrapper>
      <BodyLargeMedium>{t('employee.yourHealth.yourCheckList')}</BodyLargeMedium>
      <Container>
        {isFollowUpHandled && <NewRecommendationsBanner />}
        {checkListItems.map((item) => (
          <CheckListContainer key={item.id}>
            <Checkbox
              checked={item.checked}
              onChange={() => handleCheckboxChange(item.priority)}
              disabled={isPending}
              backgroundColor={theme.color.white}
              borderColor={theme.color.grey3}
            />
            <BodyMedium>
              <Title>{item.title}. </Title>
              {item.text}
            </BodyMedium>
          </CheckListContainer>
        ))}
      </Container>
    </CheckListWrapper>
  )
}

const CheckListContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing.medium}px;
`
const CheckListWrapper = styled.div`
  background-color: ${theme.color.beigeLight};
  padding: ${theme.spacing.mediumLarge}px;
  border-radius: ${theme.spacing.medium}px;
  ${boxShadow};
`
const Title = styled.span`
  font-weight: 500;
`
const Container = styled.div`
  border-radius: ${theme.spacing.medium}px;
  padding-top: ${theme.spacing.large}px;
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.mediumLarge}px;
  width: 100%;
  align-items: flex-start;
`
